import { MultiSelectActionsContainer } from 'src/components/common/MultiSelect/MultiSelectActionsContainer';
import { BroadcastActions } from 'src/components/Events/EventListing/InventoryEventListing/BulkActions/InventoryEventBulkActions/Actions/BroadcastActions';
import { RetailSaleActions } from 'src/components/Events/EventListing/InventoryEventListing/BulkActions/InventoryGlobalBulkActions/Actions/RetailSaleActions';
import { usePosLiteAccount } from 'src/hooks/usePosLiteAccount';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { getIsPlaceholderEvent } from 'src/utils/placeholderEventsUtils';
import { EventWithData, Feature } from 'src/WebApiController';

import { GroupActions } from './Actions/GroupActions';
import { PricingActions } from './Actions/PricingActions';
import { SettingsActions } from './Actions/SettingsActions';
import { TagsActions } from './Actions/TagsActions';

type InventoryBulkActionsProps = {
  eventWithData: EventWithData;
  isEventPage: boolean;
  listingCount: number;
};

export const InventoryEventBulkActions = (props: InventoryBulkActionsProps) => {
  const { eventWithData, isEventPage, listingCount } = props;
  const isPosLite = usePosLiteAccount();
  const hasPlaceholderEventFeature = useUserHasFeature(
    Feature.PlaceholderEventGroup
  );
  // The backend sets `placeholder` only for synthesized placeholder events,
  // so its presence authoritatively identifies them.
  const isPlaceholderEvent =
    hasPlaceholderEventFeature && getIsPlaceholderEvent(eventWithData.event);

  if (isPosLite) {
    return null;
  }

  return (
    <MultiSelectActionsContainer>
      {!isPlaceholderEvent && <GroupActions data={eventWithData} />}
      <PricingActions event={eventWithData.event} />
      <TagsActions event={eventWithData.event} />
      {!isPlaceholderEvent && (
        <BroadcastActions
          event={eventWithData.event}
          isEventPage={isEventPage}
          listingCount={listingCount}
        />
      )}
      <SettingsActions event={eventWithData.event} isEventPage={isEventPage} />
      <RetailSaleActions />
    </MultiSelectActionsContainer>
  );
};
